import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Drawer, Box, Typography } from "@mui/material";
import { List, ListItemIcon, ListItemText, Collapse } from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import styled from "styled-components";
import Logo from "../../assests/logo/hipship.png";
import { sideBarMenus } from "../../common/data";
import { getMenuSubMenu, getSubUserRoles } from "../../config/api"
import {
  HomeIcon,
  ScaleIcon,
} from "../../common/iconsData";

const StyledNavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  text-decoration: none;
  margin: 2px 10px;
  /* color: #dde6ed; */
  color: #fff;
  > div svg {
    color: #fff !important;
  }

  &:hover,
  &:active,
  &.active:link,
  &.active:visited {
    /* color: #3ba4d4; */
    /* color: #0e1f2e; */
    /* color: #fff; */
    color: #151515;
    /* background-color: #f8fafd; */
    /* background-color: #37bc9b; */
    /* background-color: #77b2dc; */
    background-color: #fff;

    box-shadow: 1px 2px 4px 0px rgba(0, 0, 0, 0.5);

    /* background-color: #37bc9b; */
    border-radius: 10px;

    > div svg {
      /* color: #0e1f2e !important; */
      color: #151515 !important;
    }
  }
`;

const StyledInsideNavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 12px;
  padding-left: 70px;
  text-decoration: none;
  margin: 2px 10px;
  /* color: #dde6ed; */
  color: #fff;

  &:hover,
  &:active,
  &.active:link,
  &.active:visited {
    /* color: #3ba4d4; */
    color: #151515;
    /* background-color: #f8fafd; */
    /* background-color: #37bc9b; */
    /* background-color: #77b2dc; */
    background-color: #fff;
    border-radius: 10px;
  }
`;

interface InsideType {
  name: string;
  path: string;
}


interface SiderBarMenusType {
  id: string;
  name: string;
  icon: JSX.Element;
  path: string;
  inside: InsideType[];
}




const SideBar = ({
  width,
  setWidth,
}: {
  width: string;
  setWidth: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const [open, setOpen] = useState<number | null>(null);

  const [mouseEnter, setMouseEnter] = useState(false);

  const handleClick = (index: number) =>
    index === open ? setOpen(0) : setOpen(index);

  const handleExtraMenu = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    index: number
  ) => {
    e.preventDefault();
    index === open ? setOpen(0) : setOpen(index);
  };

  const sideBarMouseEnter = () => {
    setWidth("300px");
    setMouseEnter(true);
  };

  const sideBarMouseLeave = () => {
    setWidth("72px");
    setMouseEnter(false);
  };

  const [menu, setMenu] = useState<SiderBarMenusType[]>([]);
  const [restrictedMenu, setRestrictedMenu] = useState<string[]>([]);
  const [userType, setUserType] = useState(false);

  useEffect(() => {
    const user_id = { 'staff_id': localStorage.getItem('hipship-user-id') ?? "", }

    {
      user_id &&
        getSubUserRoles(user_id).then((data) => {
          if (data.data.data[0] != undefined) {
            const modules = data.data.data[0].modules;
            setRestrictedMenu(modules);
            setUserType(true)
          }

        }).catch((error) => {
          console.log(error);
        })
    }




    getMenuSubMenu().then((data) => {
      setMenu(data.data.data)
      // 171 user
      // 196 subuser

    }).catch((error) => {
      console.log(error);
    })

  }, [])

  return (
    <Drawer
      onMouseEnter={sideBarMouseEnter}
      onMouseLeave={sideBarMouseLeave}
      variant="permanent"
      hideBackdrop
    >
      <Box
        sx={{
          width: width,
          height: "100%",
          // background: "#fff",
          background: "#217aee",
          // background: "#27374d",
          // background: "#37bc9b",
          overflow: "hidden",
          transition: "ease-in-out 0.4s",
        }}
      >
        <Box
          sx={{
            position: "fixed",
            width: width,
            height: "60px",
            // background: "#f5f5f7",
            // background: "#37bc9b",
            // background: "#77b2dc",
            background: "#217aee",

            boxShadow: "1px 2px 7px 0px rgba(0, 0, 0, 0.1)",

            transition: "ease-in-out 0.4s",
          }}
        >
          <NavLink to="/" className={"no-hover"}>
            <img
              draggable={false}
              src={Logo}
              alt=""
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </NavLink>
        </Box>

        <div
          style={{
            padding: "20px 0",
            marginTop: "60px",
            overflowX: "hidden",
            overflowY: "scroll",
            height: "calc(100vh - 60px)",
          }}
        >

          <List>
            {menu.map((item, index) =>
              item.inside.length === 0 ? (
                (userType === false || (userType === true && restrictedMenu?.includes(item.id))) && (
                  <StyledNavLink
                    onClick={() => handleClick(index)}
                    key={index}
                    to={item.path}
                  >
                    <ListItemIcon>{sideBarMenus[index].icon} </ListItemIcon>
                    <ListItemText>
                      <Typography
                        sx={{
                          display: `${mouseEnter ? "block" : "none"}`,
                        }}
                        fontSize={"14px"}
                        color={"inherit"}
                      >
                        {item.name}
                      </Typography>
                    </ListItemText>
                  </StyledNavLink>
                )
              ) : (

                (userType === false || (userType === true && restrictedMenu?.includes(item.id))) && (

                  <div key={index}>
                    <StyledNavLink
                      to={item.path}
                      onClick={(e) => handleExtraMenu(e, index)}
                    >
                      <Box
                        sx={{
                          display: "flex",
                        }}
                      >
                        <ListItemIcon>{sideBarMenus[index].icon} </ListItemIcon>
                        <Typography
                          sx={{
                            display: `${mouseEnter ? "block" : "none"}`,
                          }}
                          color={"inherit"}
                          fontSize={"14px"}
                        >
                          {item.name}
                        </Typography>
                      </Box>
                      <div
                        style={{
                          display: `${mouseEnter ? "block" : "none"}`,
                        }}
                      >
                        {open === index ? <ExpandLess /> : <ExpandMore />}
                      </div>
                    </StyledNavLink>
                    <Collapse in={open === index} timeout="auto" unmountOnExit>
                      <List
                        sx={{
                          display: `${mouseEnter ? "block" : "none"}`,
                        }}
                        component="div"
                        disablePadding
                      >
                        {item.inside.map((insideItem, insideIndex) => {
                          return (
                            <StyledInsideNavLink
                              key={insideItem.path}
                              to={`${item.path}/${insideItem.path}`}
                            >
                              <Typography fontSize={"13.5px"} color={"inherit"}>
                                {insideItem.name}
                              </Typography>
                            </StyledInsideNavLink>
                          );
                        })}
                      </List>
                    </Collapse>
                  </div>

                )
              )
            )}
          </List>

          {/* <List>
            {sideBarMenus.map((item, index) =>
              item.inside.length === 0 ? (
                <StyledNavLink
                  onClick={() => handleClick(index)}
                  key={index}
                  to={item.path}
                >
                  <ListItemIcon>{item.icon} </ListItemIcon>
                  <ListItemText>
                    <Typography
                      sx={{
                        display: `${mouseEnter ? "block" : "none"}`,
                      }}
                      fontSize={"14px"}
                      color={"inherit"}
                    >
                      {item.name}
                    </Typography>
                  </ListItemText>
                </StyledNavLink>
              ) : (
                <div key={index}>
                  <StyledNavLink
                    to={item.path}
                    onClick={(e) => handleExtraMenu(e, index)}
                  >
                    <Box
                      sx={{
                        display: "flex",
                      }}
                    >
                      <ListItemIcon>{item.icon}</ListItemIcon>
                      <Typography
                        sx={{
                          display: `${mouseEnter ? "block" : "none"}`,
                        }}
                        color={"inherit"}
                        fontSize={"14px"}
                      >
                        {item.name}
                      </Typography>
                    </Box>
                    <div
                      style={{
                        display: `${mouseEnter ? "block" : "none"}`,
                      }}
                    >
                      {open === index ? <ExpandLess /> : <ExpandMore />}
                    </div>
                  </StyledNavLink>
                  <Collapse in={open === index} timeout="auto" unmountOnExit>
                    <List
                      sx={{
                        display: `${mouseEnter ? "block" : "none"}`,
                      }}
                      component="div"
                      disablePadding
                    >
                      {item.inside.map((insideItem, insideIndex) => {
                        return (
                          <StyledInsideNavLink
                            key={insideItem.path}
                            to={`${item.path}/${insideItem.path}`}
                          >
                            <Typography fontSize={"13.5px"} color={"inherit"}>
                              {insideItem.name}
                            </Typography>
                          </StyledInsideNavLink>
                        );
                      })}
                    </List>
                  </Collapse>
                </div>
              )
            )}
          </List> */}
        </div>
      </Box>
    </Drawer>
  );
};

export default SideBar;
